export default __webpack_public_path__ + "media/inform_pro_user_profile_email/title_locale_it-f434d5f6.png";